$(() => {
    initPolyfills();

    initClassToggle();
    initAnchorScroll();
    initInViewAnimation();
    initSlick();
    initScrolltop();
    initVideo();
})
 

function initPolyfills() {
    // CSS object-fit for IE
    objectFitImages();

    // polyfill for IE - startsWith
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        };
    }

    // polyfill for IE - forEach
    if ('NodeList' in window && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
            thisArg = thisArg || window;
            for (var i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }
}

function isTablet() {
    return window.matchMedia('(max-width:991px)').matches;
}

function isMobile() {
    return window.matchMedia('(max-width:767px)').matches;
}
/**
 * Toggle class on click
 */
function initClassToggle() {
    $('body').on('click', '[data-toggle="class"][data-class]', (event) => {
        event.preventDefault();
        const $trigger = $(event.currentTarget);
        const $target = $(
            $trigger.data('target') ? $trigger.data('target') : $trigger.attr('href')
        );
        const newClass = $trigger.data('class');
        const newBodyClass = $trigger.data('body-class');
        const removePrev = $trigger.data('remove-prev');
        const stayActive = $trigger.data('stay-active');

        if (removePrev && !$target.hasClass(newClass)) {
            const parentSel = $trigger.data('parent');
            $(parentSel).find(`.${newClass}`).removeClass(newClass);
        }

        if ($target.length) {
            event.preventDefault();
            $trigger.toggleClass('class-toggled');
            if (stayActive) {
                $target.addClass(newClass);
                $('body').addClass(newBodyClass);
            } else {
                $('body').toggleClass(newBodyClass);
                if ($target.hasClass(newClass)) {
                    $target.removeClass('transitionstart-finished')
                            .removeClass('transitionend-finished');
                    $target.removeClass(newClass);
                    $target.one('animationend transitionend', () => {
                        $target.addClass('transitionend-finished')
                        $target.unbind('animationend transitionend');
                    });
                } else {
                    $target.removeClass('transitionstart-finished')
                            .removeClass('transitionend-finished');
                    $target.addClass(newClass);
                    $target.one('animationend transitionend', () => {
                        $target.addClass('transitionstart-finished')
                        $target.unbind('animationend transitionend');
                    })
                }
            }
        }
    });
}

/**
 * Smooth anchor scrolling
*/
function initAnchorScroll() {
    $('a[href*="#"]:not([data-toggle])').on('click', function(event) {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name="'+this.hash.slice(1)+'"]');
            if (target.length && !target.parents('.woocommerce-tabs').length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 60
                }, 1000);
            }
        }
    });
}

/**
 * Animates Opacity and TranslateY by default.
 * Only translate is able to customize. 
 * For complex animations, please setup a specific function with anime.js or other tools for it.
 * Reference: https://animejs.com/
 * 
 * dependency: 
 *      1. utilities/inview.js isElementInViewport()
 *      2. anime.js
 * 
 * wrapper: .inview-animation
 *      attr: data-inview-percent=0.2  (stands for the percentage of the view that we have seen this wrapper)
 * element: .inview-anime
 *      attr: data-anime-translate=false (disable the translateY animation)
 *            data-anime-translate='translateX' or 'translateZ' (enable the translateX/Z animation, it's translateY by default)        
 *            data-anime-translate-val=10 (set the translate start value, it starts at 32 by default, and ends at 0.)
 *            data-anime-timeline=0.5 (Adding animations to a timeline. 0.5 stands for beginning animation at the 50% point of the total animation time)
*/
function initInViewAnimation() {
    const $els = $('.inview-animation');
    const defaultInViewPercent = 0.1;
    const duration = 1000;
    const easing = 'cubicBezier(.34,.615,.4,.985)';
    const defaultTranslateY = 32;
    const defaultTranslate = 'translateY';
    const supportTranslates = ['translateX', 'translateY', 'translateZ'];

    $els.each((i, el) => {
        let isElInView = false;
        const inViewOffset = $(el).attr('data-inview-percent') || defaultInViewPercent;
        // init animation
        const animeSel = '.inview-anime';
        const $animeEls = $(el).find(animeSel);
        const animeTimeline = anime.timeline({
            duration: duration,
            autoplay: false,
            easing: easing,
        });
        $animeEls.each((_, animeEl) => {
            const translate =
                $(animeEl).attr('data-anime-translate') !== 'false'
                    ? $(animeEl).attr('data-anime-translate') || defaultTranslate
                    : false;
            const translateVal = Number($(animeEl).attr('data-anime-translate-val')) || defaultTranslateY;
            let timeOffset = Number($(animeEl).attr('data-anime-timeline')) || 0;
            timeOffset *= duration;
            let translateAnime = {};

            if (supportTranslates.includes(translate)) {
                translateAnime = {[translate]: [translateVal, 0]}
            }
            animeTimeline.add(
                {
                    targets: animeEl,
                    opacity: [0, 1],
                    ...translateAnime,
                },
                timeOffset
            );
        });

        function scrollToViewport() {
            if (isElementInViewport(el, inViewOffset) && !isElInView) {
                isElInView = true;
                animeTimeline.play();
                window.removeEventListener('scroll', scrollToViewport);
            }
        }
        scrollToViewport();
        window.addEventListener('scroll', scrollToViewport);
    });
}


function initSlick() {
     $('.module__hero-slider .slider').slick({
        slidesToShow:1,
        slidesToScroll:1,
        infinite:true,
        dots:true,
        fade: true,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 2000,
        arrows:false
    });
}

function initScrolltop() {
    $(".back-top-button").click(function () {
       $("html, body").animate({scrollTop: 0}, 1000);
    });
}

function initVideo() {
    var videoContainers = $('.video-container');
    if(videoContainers.length) {
        videoContainers.each(function() {
            var videoContainer = $(this);
            var iFrame = videoContainer.find('iframe').first();
            var overlay = videoContainer.find('.video-overlay');
            if(iFrame) {
                if(iFrame[0].src.indexOf('vimeo') !== -1) {
                    var player = new Vimeo.Player(iFrame);

                    if(overlay) {
                        overlay.on('click', function(e) {
                            videoContainer.addClass('active');
                            $(this).fadeOut();
                            player.play();
                        });
                    }
                } else if(iFrame[0].src.indexOf('youtube') !== -1) {
                    if(overlay) {
                        overlay.on('click', function(e) {
                            videoContainer.addClass('active');
                            iFrame[0].src += '&autoplay=1';

                            setTimeout(function() {
                                overlay.fadeOut();
                            }, 500);
                        });
                    }
                }
            }
        });
    }
}